// TrainingSection.js

import React, { useState, useRef, useEffect } from "react";
import "./TrainingSection.css"; // CSSファイルをインポート
import FeaturesSectionImage01 from '../assets/images/enterprise/trainings-image-01.jpeg';
import FeaturesSectionImage02 from '../assets/images/enterprise/trainings-image-02.jpeg';
import FeaturesSectionImage03 from '../assets/images/enterprise/trainings-image-03.jpeg';
import FeaturesSectionImage04 from '../assets/images/enterprise/trainings-image-04.jpeg';
import FeaturesSectionImage05 from '../assets/images/enterprise/trainings-image-05.jpeg';
import FeaturesSectionImage06 from '../assets/images/enterprise/trainings-image-06.jpeg';
import EnterpriseCourseImage01 from '../assets/images/enterprise/enterprisecourses-image-01.jpeg';
import EnterpriseCourseImage02 from '../assets/images/enterprise/enterprisecourses-image-02.jpeg';
import EnterpriseCourseImage03 from '../assets/images/enterprise/enterprisecourses-image-03.jpeg';
import EnterpriseCourseImage04 from '../assets/images/enterprise/enterprisecourses-image-04.jpeg';
import EnterpriseCourseImage05 from '../assets/images/enterprise/enterprisecourses-image-05.jpeg';
import EnterpriseCourseImage06 from '../assets/images/enterprise/enterprisecourses-image-06.jpeg';
import EnterpriseCourseImage07 from '../assets/images/enterprise/enterprisecourses-image-07.jpeg';
import EnterpriseCourseImage08 from '../assets/images/enterprise/enterprisecourses-image-08.jpeg';
import CourseDetailImage01 from '../assets/images/enterprise/detail-image-01.png';
import CourseDetailImage02 from '../assets/images/enterprise/detail-image-02.png';
import CourseDetailImage03 from '../assets/images/enterprise/detail-image-03.png';
import CourseDetailImage04 from '../assets/images/enterprise/detail-image-04.png';
import CourseDetailImage05 from '../assets/images/enterprise/detail-image-05.png';
// 必要な画像をインポート（例として仮の画像パスを使用）
// import mentoringImage1 from "../assets/images/top/training-image-01.png";

const TrainingSection = () => {

	const trainings = [
		{
		  id: 1,
		  title: '営業部：生成AIでの顧客分析',
		  description: '生成AIを活用して顧客の購買履歴やウェブ行動データを多角的に分析し、新規顧客開拓やクロスセル提案の戦略立案をサポートします。これにより営業チームは効率的なアプローチと高い成約率を実現できます。',
		  image: FeaturesSectionImage01
		},
		{
		  id: 2,
		  title: '経理部：生成AIでの業務効率化',
		  description: '日々発生する伝票や請求書データを生成AIで自動分類・集計し、月次決算や予算実績分析の業務負担を大幅に軽減します。不正リスクの検知や監査対応の迅速化にも貢献。',
		  image: FeaturesSectionImage02
		},
		{
		  id: 3,
		  title: '情報システム部：AI駆動による社内情報分析',
		  description: '社内ヘルプデスクや障害対応チケットを生成AIで自動振り分けし、初動対応を自動化。過去の対応履歴を蓄積してナレッジベースを構築することで、回答精度を継続的に向上させます。',
		  image: FeaturesSectionImage03
		},
		{
		  id: 4,
		  title: '開発チーム：AI駆動による社内開発',
		  description: 'AIによるコード生成支援やテストケース自動生成を導入し、要件定義からリリースまでの開発サイクルを高速化。品質を担保しつつ、短期間でのプロダクト開発を可能にします。',
		  image: FeaturesSectionImage04
		},
	  ];

	  const attributes = [
		{
		  id: 1,
		  title: '人材育成型',
		  description: '中核人材のリスキリングや、SES企業における待機者に対する教育が対象になります。学びながら賃金助成を得ることができます。',
		  image: FeaturesSectionImage05
		},
		{
		  id: 2,
		  title: '新入社員研修型',
		  description: '実践的な開発力が身につき、即戦力となります。チーム開発を想定した経験を積むことができます。',
		  image: FeaturesSectionImage06
		},
		{
		  id: 3,
		  title: '社内開発促進型',
		  description: '自社サービス開発を実装する力をつけることができます。様々な言語に対応しております。',
		  image: FeaturesSectionImage04
		},
	  ];

	  const enterprisecourses = [
		{
		  id: 1,
		  title: 'DX、AI活用コース',
		  description: '生成AIを活用して顧客の購買履歴やウェブ行動データを多角的に分析し、新規顧客開拓やクロスセル提案の戦略立案をサポートします。これにより営業チームは効率的なアプローチと高い成約率を実現できます。',
		  image: EnterpriseCourseImage01
		},
		// {
		//   id: 2,
		//   title: 'Microsoftコース',
		//   description: 'Microsoft 365やPower Platformによる業務アプリ自動化を学び、組織のIT基盤を効率的に運用するスキルを身につけます。',
		//   image: EnterpriseCourseImage02
		// },
		{
		  id: 3,
		  title: 'AIアプリ開発コース',
		  description: 'PythonやJavaScriptを用いたAIモデルの実装から、Reactによるアプリ連携まで幅広く学び、実践的なAIアプリを開発・デプロイする手法を習得します。',
		  image: EnterpriseCourseImage03
		},
		{
		  id: 4,
		  title: 'データサイエンティストコース',
		  description: '統計解析、機械学習アルゴリズム、可視化ライブラリの活用を通じて、大規模データの前処理からモデル構築、評価、運用までの一連のデータサイエンス手法を体得します。',
		  image: EnterpriseCourseImage04
		},
		// {
		//   id: 5,
		//   title: '組み込みエンジニア C言語コース',
		//   description: 'C言語によるマイコン制御やリアルタイムOSの基礎、センサー制御や通信プロトコルの実装を学び、高信頼組み込みシステム開発に必要な技術を習得します。',
		//   image: EnterpriseCourseImage05
		// },
		// {
		//   id: 6,
		//   title: '組み込みエンジニア Javaコース',
		//   description: 'Javaを用いた組み込みシステム開発手法、Android ThingsやJava MEのプラットフォーム上でのアプリ実装やデバイス連携技術を実践的に学びます。',
		//   image: EnterpriseCourseImage06
		// },
		{
		  id: 7,
		  title: 'Webアプリ開発コース',
		  description: 'HTML/CSS/JavaScriptに加え、Node.jsやReactなどのフレームワークを用いて、レスポンシブWebアプリの設計からバックエンド・API開発までを総合的に学びます。',
		  image: EnterpriseCourseImage07
		},
		{
		  id: 8,
		  title: 'iOSアプリ開発コース',
		  description: 'SwiftとXcodeを活用したiOSアプリ開発の基礎から、UIKitやSwiftUIによるUI設計、CoreData・外部API連携による実践的モバイル開発技術を習得します。',
		  image: EnterpriseCourseImage08
		},
	  ];

	  const details = [
		{
		  id: 1,
		  title: 'DX、AI活用コース',
		  image: CourseDetailImage01
		},
		{
		  id: 2,
		  title: 'AIアプリ開発コース',
		  image: CourseDetailImage02
		},
		{
		  id: 3,
		  title: 'データサイエンティストコース',
		  image: CourseDetailImage03
		},
		{
		  id: 4,
		  title: 'Webアプリ開発コース',
		  image: CourseDetailImage04
		},
		{
		  id: 5,
		  title: 'iOSアプリ開発コース',
		  image: CourseDetailImage05
		},
	  ];
	  
	return (
		<div className="training-section">
			<h2 className="training-title">Training</h2>
			<p>法人向け助成金対応の研修を行なっています。</p>

			<div className="training-container">
				<div className="main-training">
					<h3>実践型/助成金対応の法人研修</h3>
					<div className="training-grid">
						{trainings.map((trainings) => (
							<div key={trainings.id} className='training-item'>
								<img src={trainings.image} alt={trainings.title} className='training-image' />
								<h4><i class="fa-solid fa-circle"></i>{trainings.title}</h4>
								<p>{trainings.description}</p>
							</div>
						))}
					</div>
				</div>
			</div>

			<div className="training-container">
				<div className="main-training">
					<h3>対象者</h3>
					<div className="attributes-grid">
						{attributes.map((attributes) => (
							<div key={attributes.id} className='training-item'>
								<img src={attributes.image} alt={attributes.title} className='training-image' />
								<h4><i class="fa-solid fa-circle"></i>{attributes.title}</h4>
								<p>{attributes.description}</p>
							</div>
						))}
					</div>
				</div>
			</div>

			<div className="training-container">
				<div className="main-training">
					<h3>コース内容</h3>
					<div className="training-grid">
						{enterprisecourses.map((enterprisecourses) => (
							<div key={enterprisecourses.id} className='training-item'>
								<img src={enterprisecourses.image} alt={enterprisecourses.title} className='training-image' />
								<h4><i class="fa-solid fa-circle"></i>{enterprisecourses.title}</h4>
								<p>{enterprisecourses.description}</p>
							</div>
						))}
					</div>
				</div>
			</div>

			<div className="training-container">
				<div className="main-training">
					<h3>研修内容</h3>
					<div className="training-grid">
						{details.map((details) => (
							<div key={details.id} className='training-item'>
								<h4><i class="fa-solid fa-circle"></i>{details.title}</h4>
								<img src={details.image} alt={details.title} className='details-image' />
								{/* <p>{attributes.description}</p> */}
							</div>
						))}
					</div>
				</div>
			</div>

		</div>
	);
};

export default TrainingSection;